<template>
   <div>
      <thank-you-header :supplier-name="switched.supplierName" :reference-number="switched.referenceNumber"
         :already-switched="alreadySwitched"></thank-you-header>
      <div class="container">
         <div class="row _margin-top-40">
            <div :class="{ 'col-md-4': carbonOffset, 'col-md-12': !carbonOffset }">
               <h5 class="_margin-bottom-30">WHAT HAPPENS NEXT?</h5>

               <div class="row">
                  <div class="_margin-bottom-30" :class="{ 'col-md-12': carbonOffset, 'col-md-4': !carbonOffset }">
                     <div class="card">
                        <h6 class="_margin-bottom-10">Your Switch</h6>
                        <p>
                           Your switch should normally be complete within 5 to 10 working days. {{ switched.supplierName
                           }} will be in contact with you shortly to confirm your
                           Supply Start Date (SSD) and provide you with a welcome pack/letter, which will include the
                           full Terms & Conditions.
                        </p>
                        <p>
                           Your SSD will be impacted if you asked to delay your switch after your cooling off period is
                           over.
                        </p>

                        <h6 class="_margin-bottom-10">Cooling Off</h6>
                        <p class="_margin-bottom-0">
                           You have the right to change your mind within 14 days. Information provided by your new
                           Supplier will detail
                           what your statutory cooling-off rights are.
                        </p>
                     </div>
                  </div>

                  <div class="_margin-bottom-30" :class="{ 'col-md-12': carbonOffset, 'col-md-4': !carbonOffset }">
                     <div class="card">
                        <h6 class="_margin-bottom-10">Opening Meter Reads</h6>
                        <p class="_margin-bottom-0">
                           Your new Supplier may require you to take a meter reading on, or close to, the day of your
                           switch.
                        </p>
                     </div>
                  </div>

                  <div class="_margin-bottom-20" :class="{ 'col-md-12': carbonOffset, 'col-md-4': !carbonOffset }">
                     <div class="card">
                        <h6 class="_margin-bottom-10">Unpaid Debt</h6>
                        <p class="_margin-bottom-0">
                           Should you have any outstanding charges with your current Supplier, this may impact
                           the progress of your switch.
                        </p>
                     </div>
                  </div>
               </div>
            </div>

            <div class="col-md-4 _margin-top-10" v-if="carbonOffset">
               <div class="_margin-top-50 visible-md visible-lg"></div>
               <div class="card _margin-bottom-20">
                  <h5>Offset your carbon footprint!</h5>
                  <p>Your household gas carbon footprint:</p>
                  <div class="footprint">

                     <img src="../../assets/foot-print.svg" alt="carbon foot print icon">
                     <h4 class="_margin-top-10">{{ carbonOffsetEquivalent.carbonFootprint | number(1) }} <small>tons
                           CO<sub>2</sub>/year</small></h4>
                  </div>

                  <uiv-btn type="primary" @click="onOffset">
                     Offset my carbon now!
                  </uiv-btn>
               </div>
            </div>

            <div class="col-xs-12" v-if="carbonOffset">
               <small v-if="app_settings.whiteLabel">
                  Your Switch has been facilitated by MyUtilityGenius on behalf of {{ app_settings.supplierName }}.
                  MyUtilityGenius have partnered up with C-LEVEL to bring you the opportunity to offset your carbon
                  footprint.
                  Your personal details and payment information shall be shared securely between C- level and their
                  payment
                  partner to complete your offset. Upon completion, C-level shall issue you your carbon offset
                  certificate
                  which will be sent to the email address you supply upon payment. Any amendments you wish to make or if
                  you
                  just want to find out more on your carbon offset, please contact C-Level directly quoting the
                  reference number
                  that shall be provided to you upon completion. Your reference number may also be provided on
                  certificate issued.
               </small>

               <small v-if="!app_settings.whiteLabel">
                  Your Switch has been facilitated by MyUtilityGenius on behalf of {{ app_settings.supplierName }}.
                  MyUtilityGenius have partnered up with C-LEVEL to bring you the
                  opportunity to offset your carbon footprint. Your personal details and payment information shall be
                  captured between C- level and their payment partner
                  to complete your offset. Upon completion, C-level shall issue you your carbon offset certificate which
                  will be sent to the email address you supply upon payment.
                  Any amendments you wish to make, or if you just want to find out more on your carbon offset, please
                  contact C-Level directly quoting the reference number that
                  shall be provided to you upon completion. Your reference number may also be provided on certificate
                  issued.
               </small>
            </div>
         </div>
      </div>

      <notify-complete-switch />
   </div>
</template>

<script>
import ThankYouHeader from '@/components/thank-you-header/ThankYouHeader';
import NotifyCompleteSwitch from '@/components/notify-complete-switch/NotifyCompleteSwitch.vue';
import { mapState } from 'vuex';

export default {
   name: 'SwitchComplete',
   async mounted() {
      if (!this.switched) {
         this.$router.push({ name: 'currentTariff' });
      }

      this.$store.dispatch('page_loader/start', 0);
      await this.$store.dispatch('token/getToken');
      await this.$store.dispatch('carbon_offset/getCarbonEquivalent');
      this.$store.dispatch('page_loader/stop');
   },
   computed: {
      ...mapState({
         carbonOffset: ({ app_settings, storage }) => {
            return app_settings.carbonOffset && storage.quote.switchType != 'electricityToElectricity';
         },
         carbonOffsetProjects: ({ carbon_offset }) => carbon_offset.projects,
         carbonOffsetEquivalent: ({ carbon_offset }) => carbon_offset.equivalent,
         switched: ({ storage }) => storage.switched,
         alreadySwitched: ({ storage }) => storage.alreadySwitched,
         app_settings: ({ app_settings }) => app_settings
      })
   },
   methods: {
      async onOffset() {
         this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Switch Complete' });
         this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Offset Your Carbon' });
         await this.$store.dispatch('tracing/saveActions');
         this.$router.push({ name: 'carbonOffset' });
      }
   },
   components: {
      ThankYouHeader,
      NotifyCompleteSwitch
   }
};
</script>

<style lang="scss" scoped>
.footprint {
   position: relative;
   padding: 0px 15px 0px 30px !important;

   img {
      position: absolute;
      max-width: 22px;
      top: -6px;
      left: 0;
   }
}
</style>
